import { NamedComplexEnumItem } from '../../../utils/complexEnum/NamedComplexEnumItem'

export class CustomListItemStyleItem<
  ID extends string = string,
  Name extends string = string
> extends NamedComplexEnumItem<ID, Name> {
  /**
   * the full label with {@link BasicComplexEnumItem.name|name} and {@link help}
   */
  label: string
  /**
   * the help text
   */
  help: string
  constructor({
    help,
    label,
    ...named
  }: Pick<
    CustomListItemStyleItem<ID, Name>,
    'help' | 'id' | 'label' | 'name'
  >) {
    super(named)
    this.help = help
    this.label = label
  }
}
